module.exports = __webpack_public_path__ + "static/media/ppe_saf_har.724a758e.png";